import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import {
  LanguageConfig,
  LanguageSwitcher,
} from '@zipari/shared-ds-util-navigation';

@Component({
  selector: 'language-dropdown',
  templateUrl: './language-dropdown.component.html',
})
export class LanguageDropdownComponent {
  @Input() config: LanguageSwitcher;
  @Input() activeLangKey: string;
  @Input() isMobileView = false;
  @Output() languageSwitched = new EventEmitter<LanguageConfig>();
  public selectedLanguage = new UntypedFormControl(null);
  public valueKey = 'key';
  public displayProperty = 'label';

  public get languagesSwitcherEnabled(): boolean {
    const langList = this.config?.listOfLanguages?.languages;
    const isEnabled = this.config?.enabled;

    return isEnabled && langList?.length > 1;
  }

  public handleLanguageChange(language: LanguageConfig): void {
    this.languageSwitched.emit(language);
  }
}
